import { FC, useEffect, useState } from 'react'
import Select from 'react-select'
import { ROLES } from '../../../Utils/Constant/roles'
import { useDispatch, useSelector } from 'react-redux'
import { getAllUserDetails } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useLazyGetSalesPotentialChurnUserQuery, useUpdateStatusUsedCouponMutation } from '../../../../services/cellcast'
import { GetAllStaff } from '../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import { KTSVG } from '../../../../_metronic/helpers'
import { toast } from 'react-toastify'
import { PotentialChurnTable } from './components/PotentialChurnTable'

const PotentialChurn: FC = () => {
  const dispatch = useDispatch()
  const userDetail = useSelector(getAllUserDetails)
  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)
  const staffListOptions = () => {
    const defaultOptions = [{
      value: ``,
      label: `All`,
    }]

    const list = stafflist?.items ? stafflist?.items?.map((key: any) => ({
      value: `${key?._id}`,
      label: `${key?.name}`,
    })) : [];
    return [...defaultOptions, ...list];
  };

  const [params, setParams] = useState({
    staffId: userDetail.role === ROLES.SUPER_ADMIN ? '' : userDetail?._id,
    page: 1,
    limit: 10,
    search: ''
  })
  const [searchTerm, setSearchTerm] = useState(params.search || '')

  const [fetch, { isLoading, data }] = useLazyGetSalesPotentialChurnUserQuery()
  const [updateStatusUsedCouponMutation] = useUpdateStatusUsedCouponMutation()

  useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  useEffect(() => {
    const handler = setTimeout(() => {
      setParams(prev => ({
        ...prev,
        search: searchTerm,
        page: 1,
      }))
    }, 300)

    return () => clearTimeout(handler)
  }, [searchTerm])

  useEffect(() => {
    dispatch(
      GetAllStaff({
        page: {
          page: 1,
          size: 10,
          search: '',
        },
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

const handleSetParams = (field: string, value: any) => {
  setParams(prev => {
    const newParams = { ...prev, [field]: value };

    if (field === 'staffId') {
      newParams.page = 1;
    }

    return newParams;
  });
};

  const handleUpdateStatusUsedCoupon = async (id: string, status: boolean) => {
    try {
      const result = await updateStatusUsedCouponMutation({ userId: id, hasUsedCoupon: status }).unwrap()
      if (result) {
        toast.success('Status updated successfully')
      } else {
        toast.error('Failed to update status')
      }
      fetch(params)
    } catch (error) {
      console.error('Failed to update the status of the used coupon:', error)
      toast.error('Failed to update status')
    }
  }

  return (
    <div className='mt-8'>
      <div className='card mt-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3'>Potential Churn</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Potential churn account</span>
          </h3>

          <div className='d-flex align-items-center gap-4'>
            {/* Search */}
            <div className='position-relative'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute top-50 translate-middle-y ms-4'
              />
              <input
                type='text'
                value={searchTerm || ''}
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-200px ps-10'
                placeholder='Search user'
                onChange={(e: any) => setSearchTerm(e.target.value)}
              />
            </div>

            {userDetail.role === ROLES.SUPER_ADMIN && (
              <Select
                onChange={(e: any) => handleSetParams('staffId', e.value)}
                options={staffListOptions()}
                className='w-200px'
              />
            )}
          </div>
        </div>
        <PotentialChurnTable
          data={data?.data}
          isFetching={isLoading}
          handleSetParams={handleSetParams}
          updateStatusUsedCoupon={handleUpdateStatusUsedCoupon}
        />
      </div>
    </div>
  )
}

export default PotentialChurn